import { render } from "./AcknowledgedAgreements.vue?vue&type=template&id=6f4f1528&scoped=true"
import script from "./AcknowledgedAgreements.vue?vue&type=script&lang=js"
export * from "./AcknowledgedAgreements.vue?vue&type=script&lang=js"

import "./AcknowledgedAgreements.vue?vue&type=style&index=0&id=6f4f1528&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4f1528"]])

export default __exports__